import { HttpAgent } from "@ag-ui/client";
import { useApiToken } from "@appretio/api";
import { useCallback } from "react";
import { runChatTurn } from "./chatAgent";

/**
 * Returns a function that streams one prompt through the AG-UI agent. Reply
 * chunks fire `onDelta` as they arrive (typing effect); the promise resolves
 * once the turn finishes.
 *
 * Nothing is returned: the agent owns the conversation, so there is no id or
 * message history for the caller to thread into the next request.
 *
 * A `useCallback` rather than a TanStack mutation because the incremental
 * `onDelta` lifecycle doesn't fit the single-result mutation model; the caller
 * owns in-flight + error state.
 */
export function useSendMessage() {
  const getToken = useApiToken();

  return useCallback(
    async (
      agent: HttpAgent,
      prompt: string,
      onDelta: (text: string) => void
    ): Promise<void> => {
      const token = await getToken();
      await runChatTurn(agent, prompt, token, onDelta);
    },
    [getToken]
  );
}
